<template>
  <div v-show="noticeText" class="notice-container">
    <div id="storeNoticeAlert" ref="noticeAlert" :class="{
      'notice-mobile': $vuetify.breakpoint.mdAndDown, expanded: isExpanded, 'has-see-more': isTruncated,
      'no-see-more': !isTruncated
    }" :style="computedStyleObject">
      <div>
        <div class="notice-text" ref="noticeText">{{ noticeText }}</div>
        <button v-if="isTruncated" @click="toggleExpand" class="see-more-btn">
          {{ isExpanded ? 'See Less' : 'See More' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noticeText: {
      type: String,
      default: ''
    },
    boxShadow: {
      type: String,
      default: '0 0 11px rgba(33,33,33,.2)'
    }
  },
  data() {
    return {
      isExpanded: false,
      isTruncated: false
    };
  },
  computed: {
    resolvedBgColor() {
      const store = this.$store && this.$store.getters && this.$store.getters.getStore;
      const fromStore = store && store.settings && store.settings.owaSettings && store.settings.owaSettings.bannerSettings && store.settings.owaSettings.bannerSettings.backgroundColor;
      if (fromStore && fromStore !== '') {
        return fromStore;
      }
      return '#FFFFFF';
    },
    resolvedTextColor() {
      const store = this.$store && this.$store.getters && this.$store.getters.getStore;
      const fromStore = store && store.settings && store.settings.owaSettings && store.settings.owaSettings.bannerSettings && store.settings.owaSettings.bannerSettings.textColor;
      if (fromStore && fromStore !== '') {
        return fromStore;
      }
      return '#000000';
    },
    computedStyleObject() {
      return {
        boxShadow: `${this.boxShadow} !important`,
        backgroundColor: this.resolvedBgColor,
        color: this.resolvedTextColor
      };
    }
  },
  watch: {
    noticeText: {
      immediate: true,
      handler() {
        this.checkTruncation();
      }
    }
  },
  mounted() {
    this.checkTruncation();
    window.addEventListener('resize', this.checkTruncation);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkTruncation);
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
      const element = this.$refs.noticeAlert;
      if (element) {
        if (this.isExpanded) {
          element.classList.add('expanded');
        } else {
          element.classList.remove('expanded');
        }
      }
    },
    checkTruncation() {
      this.$nextTick(() => {
        const textElement = this.$refs.noticeText;
        if (textElement) {
          const computedStyle = getComputedStyle(textElement);
          const lineHeight = parseFloat(computedStyle.lineHeight);
          const maxHeight = lineHeight * 2 + 1; // note: + 1 is 1px buffer
          const contentHeight = textElement.scrollHeight;
          this.isTruncated = contentHeight > maxHeight;
        }
      });
    }
  }
};
</script>
<style scoped>
.notice-container {
  position: fixed;
  top: 64px;
  width: 100%;
  z-index: 2;
}

#storeNoticeAlert {
  text-align: center;
  font-size: var(--text-size-2);
  font-weight: 600;
  line-height: calc(var(--text-size-2) + 5px);
  padding: 10px;
  padding-bottom: 0px;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  transition: height 0.3s ease;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.see-more-btn {
  float: right;
  margin-right: 10px;
  font-size: 11px;
}

.notice-text {
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  margin-bottom: -5px;
}

#storeNoticeAlert.has-see-more {
  padding-bottom: 0px;
}

#storeNoticeAlert.no-see-more {
  padding-bottom: 10px;
}

#storeNoticeAlert.expanded .notice-text {
  display: block;
  line-clamp: unset;
  -webkit-line-clamp: unset;
  overflow: visible;
}
</style>